<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image class="img" :src="$t('menu.OpinionOrAdviceImg')" alt=""></el-image>
        </el-container>
      </el-col>
    </el-row>
    <div class="content">
      <el-row>
        <el-col :span="7">
          <Content>
            <template #MingChen>
              <div>{{ $t("menu.contactUs") }}</div>
            </template>

            <template #ContentEr>
              <div class="inlineer">
                <li>
                  <router-link to="/SurveyandQuotation">
                    <div>{{ $t("menu.SurveyAndQuotation") }}</div></router-link
                  >
                </li>
              </div>
            </template>

            <template #ContentSan>
              <div class="inlineer">
                <li>
                  <router-link to="/OpinionOrAdvice">
                    <div style="color: #1d2088">{{ $t("menu.suggestion") }}</div></router-link
                  >
                </li>
              </div>
            </template>
     
          </Content>
        </el-col>
        <el-col :span="17">
          <!-- <el-col :span="18"> -->
          <div class="inline">
            <el-divider direction="vertical"></el-divider>
            <h3 class="Xjiao">{{ $t("menu.suggestion") }}</h3>
          </div>
          <!-- </el-col> -->

          <div class="fff">
            <el-form
              :model="form"
              :rules="rules"
              ref="form"
              class="demo-ruleForm"
            >
              <!-- :model="ruleForm"    -->

              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item :label="$t('menu.name')" prop="name">
                    <el-input v-model="form.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" :offset="2">
                  <el-form-item :label="$t('menu.phone')" prop="tel">
                    <el-input v-model="form.tel"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- v-model="ruleForm.checkPass" -->
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item :label="$t('menu.mailbox')" prop="mailbox">
                    <el-input v-model="form.mailbox"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" :offset="2">
                  <el-form-item :label="$t('menu.companyName')" prop="companyName">
                    <el-input v-model="form.companyName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="18">
                  <el-form-item :label="$t('menu.suggestion')" prop="details">
                    <el-input type="textarea" v-model="form.details"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>




              <el-row :gutter="10">
                <el-col :span="24">
                  <p class="red">
                    {{ $t("menu.offer") }}
                  </p>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button size="mini" round @click="BtnSend()">            {{ $t("menu.send") }}</el-button>

                <el-button size="mini" @click="resetForm()" round> {{ $t("menu.reset") }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>

        <div class="right">
         {{ $t("menu.pleaseAdvise") }}
        </div>
      </el-row>
    </div>
    <!-- 底部 -->
    <MyFooter> </MyFooter>
  </div>
</template>

  
<style  lang="less" scoped>
.right {
  background: #1d2088;
  color: #ffffff;
  // float: right;
  font-size: 12px;
  width: 136px;
  position: absolute;
  right: 0px;
  padding: 30px 10px;
  line-height: 25px;
  margin-top: 20px;
}
/deep/ .el-form-item__label {
  font-weight: 400;
  font-size: 16px;
}
/deep/ .el-textarea__inner {
  height: 80px;
}

.red {
  // margin-top: 20px;
  font-size: 12px;
  color: #ff0000;
}
.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
}
.conta {
  margin-top: 161px;
}
.SanJiao {
  position: relative;
  bottom: 40px;
  left: 228px;
}

.shisi {
  font-size: 14px;
  background: #ffffff;
  padding: 10px;
  padding-left: 20px;
}
.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.divider {
  background-color: #eeeeee;
}
.fff {
  background: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
  padding-top: 0px;
}
span {
  font-size: 16px;

  color: #333333;
}
p {
  color: #666666;
  font-size: 12px;
}
a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
a:-webkit-any-link:focus,
a:-webkit-any-link:hover {
  color: #1d2088;
}

</style>

<script>
export default {
  name: "OpinionOrAdvice",

  data() {
    //合法的邮箱
    var checkEmail = (rule, value, cb) => {
      //验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        return cb();
      }
      cb(new Error( this.$t('menu.messageHeFaEamil')));
    };
    //  验证手机号的规则
    var checkPhone = (rule, value, cb) => {
      //验证邮箱的正则表达式
      const regPhone =
        /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (regPhone.test(value)) {
        return cb();
      }
      cb(new Error( this.$t('menu.messageHeFaPhone')));
    };

    return {
      number: "6-2",

      form: {
        name: "",
        tel: "",
        mailbox: "", //邮箱
        companyName: "", //公司名称
        details: "", // 建议内容
      },

      rules: {
        name: [
          { required: true, message:  this.$t('menu.messageOne'), trigger: "blur" },
        ],
        tel: [
          { required: true, message:  this.$t('menu.messageTwo'), trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        mailbox: [
          { required: true, message:  this.$t('menu.messageSan'), trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        companyName: [
          { required: true, message: this.$t('menu.messageGongSi'), trigger: "blur" },
        ],

        details: [
          { required: true, message:  this.$t('menu.messageYiJian'), trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 重置功能
    resetForm() {
      this.$refs.form.resetFields();
    },
    clearForm(){
      
    },
    // 发送按钮
    BtnSend() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        // 可以发起添加网络的请求
        const { data: res } = await this.$http.post(
        "/ContactUs/AddFeedback",
        this.form,
        {  header:{"content-type": "application/json-patch+json"}}
          //  header:{"content-type": "application/json-patch+json"},
        );

        //   this.axios({
        //   url: 'https://lab.sealtech.com/api/ContactUs/AddFeedback',
        //   method: 'post',
        //   data: this.form,
        //   header:{'Content-Type': 'application/json'}
        //   })
          console.log(res)

        if (res.code === 200) {
           this.$refs.form.resetFields();
             this.$message.success("提交建议反馈成功! ");
        }else{        
       this.$message.error("提交建议反馈失败! ");
       }
      });
    },
  },
};
</script>